/*
 * @Author: Dom
 * @Date: 2022-05-25 16:51:08
 * @LastEditTime: 2022-05-31 15:06:34
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\personal\component\phone\service.ts
 */
import request from '@/utils/request';
import { ApiPhoneParamsType } from './data';

export async function bindUserPhone(params:ApiPhoneParamsType): Promise<any> {
    return request({
        url: '/seller/v1/login/bindUserPhone',
        method: 'POST',
        data: params,
    });
}

export async function changeUserPhone(params:ApiPhoneParamsType): Promise<any> {
    return request({
        url: '/seller/v1/login/changeUserPhone',
        method: 'POST',
        data: params,
    });
}
